import React, { Component } from 'react';

class ButtonSubmit extends Component {
    render() {

        return (
            <div>
                <button type="submit" id="submit" className="submit-button">
                    Submit your meal !
                </button>
            </div>
        )
    }
}

export default ButtonSubmit;    